import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import GridFw from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";
import { PAGE_MODE } from "../../../constants/constants";
import { LoadUtil } from '../../../framework/util/LoadUtil';
import { RequestUtil } from '../../../util/RequestUtil';
import { EnvConstants } from '../../../EnvConstants';
import FormFw from '../../../framework/form/FormFw';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import React from 'react';

export class SolicitudesEjecutadasResultadoPage extends BasePage {

  createPageProperties = (pageApi) => {
    return {
      icon: 'none',
    };
  }

  renderPage(pageApi) {
    const getlistcadenaForm = () => pageApi.getComponent('form');

    const formlistcadenaConfig = {
      layout: 'vertical',
      title: 'Filtro de Búsqueda',
      load: {
        validation: () => pageApi.getParamId() != null,
        queryId: 870,
        params: { id_cadena: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: 'detalle', label: '', column: 12, readOnly: true },
        { name: 'id_ss', label: '', type: 'hidden' },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW)
          formApi.load();
      }
    }

    const gridlistcadenaConfig = {
      autoLoad: true,
      load: {
        queryId: 896,
        params: {
          id_cadena: pageApi.getParamId()
        },
        hideMessage: true,
        hideMessageError: true,
      },
      expandableAsync: async (record) => {
        const reqParams = LoadUtil.getReqParams({
          queryId: 897,
          params: () => ({
            id_muestra: record.ID_MUESTREO
          }),
        });

        const data = await RequestUtil.postData(EnvConstants.GET_URL_READ(), reqParams)
          .then((resp) => resp.dataList)
          .catch(() => []);

        return (
          <table border="1" cellPadding="6" cellSpacing="0" width="100%">
            {
              data.map((el, key1) => {
                const arrEspec = JSON.parse(el.especificacion);
                return (
                  JSON.parse(el.parametros || '[]').length > 0 &&
                  <React.Fragment key={key1}>
                    <thead>
                      <tr><th colSpan={4 + JSON.parse(el.especificacion).length}>{el.laboratorio}</th></tr>
                      <tr>
                        <th>Parámetro</th>
                        <th>Resultado</th>
                        <th>(±)</th>
                        <th>U.M.</th>
                        {
                          JSON.parse(el.especificacion).map((i, key2) => (
                            <th key={key2}>{i.normativa}</th>
                          ))
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {
                        JSON.parse(el.parametros || '[]').map((it, key) => (
                          <tr key={key}>
                            <td>{it.parametro}</td>
                            <td>{it.resultado}</td>
                            <td>{it.incertidumbre}</td>
                            <td>{it.unidad_medida}</td>
                            {
                              arrEspec?.map(esp => (
                                it?.detalle?.map(det => (
                                  <>
                                    {
                                      esp.id_espec === det.id_espec && 
                                      <td style={{ background: det.alerta === 'NO CUMPLE' ? 'red' : det.alerta === 'CUMPLE' ? 'green' : '' }}>{det.alerta}</td>
                                    }
                                  </>
                                ))
                              ))
                            }
                          </tr>
                        ))
                      }
                    </tbody>
                  </React.Fragment>
                )
              })
            }
          </table>
        )
      },
      fields: [
        { name: 'descripcion', label: 'Descripción' },
      ]
    };

    const barButtonlistcadenaconfig = {
      fields: [
        { ...BUTTON_DEFAULT.RETURN, label: "Regresar", onClick: () => this.props.history.push(`/solicitudes-ejecutadas/solicitudes-ejecutadas/${getlistcadenaForm().getData()?.id_ss}`), },
      ]
    }

    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formlistcadenaConfig}
        />
        <BarButtonFw
          name="bar"
          getParentApi={pageApi.getApi}
          config={barButtonlistcadenaconfig}
        />
        <GridFw
          name="grid"
          getParentApi={pageApi.getApi}
          config={gridlistcadenaConfig}
        />
      </>
    )
  }
}

export default withRouter(SolicitudesEjecutadasResultadoPage);